import { Dtos, SuretyAccountId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { logError } from "../../utils/error";
import { useRequest } from "../../utils/request";
import { wipQueryKey } from "./account.keys";

export const useCreateWorkInProgressStatement = (accountId: SuretyAccountId) => {
	const { post } = useRequest();
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: async (data: Dtos.WipStatement.Create.Request): Promise<void> => {
			await post(`/v2/surety/accounts/${accountId}/work-in-progress-statements`, data, "none");
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: wipQueryKey(accountId) });
		},
		onError: (error: Error) => {
			logError(error);
		},
	});

	return {
		createWipStatement: mutation.mutateAsync,
		createWipStatementIsLoading: mutation.isPending,
		createWipStatementError: mutation.error,
		resetCreateWipStatementError: mutation.reset,
	};
};
